import { loadCSRFFromMetaTag } from "@bleu.builders/ui";

export const client = async (path: string | URL, options: RequestInit = {}) => {
  const config = {
    method: options.body ? "POST" : "GET",
    ...options,
    headers: new Headers({
      "X-CSRF-Token": loadCSRFFromMetaTag(),
      ...options.headers,
    }),
  };

  const body = config.body
    ? config.body instanceof FormData
      ? config.body
      : JSON.stringify(config.body)
    : undefined;

  const response = await fetch(path, { ...config, body });

  return response.ok ? await response.json() : Promise.reject(response);
};
